import { Component, OnDestroy, OnInit } from '@angular/core';
import { AppointmentsService } from '../../../../services/appointments/appointments.service.js';
import { MatTooltipModule } from "@angular/material/tooltip";
import { MatIconModule } from "@angular/material/icon";
import { MatButtonModule } from "@angular/material/button";
import { MatTabsModule } from '@angular/material/tabs';

/** The survey answer page */
@Component({
	selector: 'app-appointment-pre-visit',
	imports: [
		MatIconModule,
		MatButtonModule,
		MatTooltipModule,
		MatTabsModule
	],
	templateUrl: './appointment-pre-visit.component.html',
	styleUrl: './appointment-pre-visit.component.scss'
})
export class AppointmentPreVisitComponent implements OnInit, OnDestroy {

	constructor(private appointmentsService: AppointmentsService) {

	}

	getContent() {

		return JSON.stringify(this.appointmentsService.appointmentDetail.previsit??"",undefined,4).trim();
	}

	ngOnInit() {
	}

	ngOnDestroy() {
	}
}
